
  import { integrationsService } from '@/services/integrations/integrationsService';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { pushRoute } from '@/ui/helpers';
  import { defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      ConfirmationModal,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const isModalOpen = ref(false);

      const showDeleteConfirmation = () => {
        isModalOpen.value = true;
      };

      const hideDeleteConfirmation = () => {
        isModalOpen.value = false;
      };

      const deleteIntegration = () => {
        integrationsService.destroyAllInstances(store.integration!).then(() => {
          isModalOpen.value = false;
          pushRoute({ name: 'integrationDetailsOverview' });
        });
      };

      return {
        showDeleteConfirmation,
        hideDeleteConfirmation,
        isModalOpen,
        deleteIntegration,
      };
    },
  });
